import _asyncToGenerator from "/opt/projects/mld24/admin_frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import { clonePseudoElements } from './clone-pseudos';
import { createImage, toArray, isInstanceOfElement } from './util';
import { getMimeType } from './mimes';
import { resourceToDataURL } from './dataurl';
function cloneCanvasElement(_x) {
  return _cloneCanvasElement.apply(this, arguments);
}
function _cloneCanvasElement() {
  _cloneCanvasElement = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(canvas) {
    var dataURL;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          dataURL = canvas.toDataURL();
          if (!(dataURL === 'data:,')) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", canvas.cloneNode(false));
        case 3:
          return _context.abrupt("return", createImage(dataURL));
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _cloneCanvasElement.apply(this, arguments);
}
function cloneVideoElement(_x2, _x3) {
  return _cloneVideoElement.apply(this, arguments);
}
function _cloneVideoElement() {
  _cloneVideoElement = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(video, options) {
    var canvas, ctx, _dataURL, poster, contentType, dataURL;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!video.currentSrc) {
            _context2.next = 8;
            break;
          }
          canvas = document.createElement('canvas');
          ctx = canvas.getContext('2d');
          canvas.width = video.clientWidth;
          canvas.height = video.clientHeight;
          ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          _dataURL = canvas.toDataURL();
          return _context2.abrupt("return", createImage(_dataURL));
        case 8:
          poster = video.poster;
          contentType = getMimeType(poster);
          _context2.next = 12;
          return resourceToDataURL(poster, contentType, options);
        case 12:
          dataURL = _context2.sent;
          return _context2.abrupt("return", createImage(dataURL));
        case 14:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _cloneVideoElement.apply(this, arguments);
}
function cloneIFrameElement(_x4) {
  return _cloneIFrameElement.apply(this, arguments);
}
function _cloneIFrameElement() {
  _cloneIFrameElement = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(iframe) {
    var _a;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          if (!((_a = iframe === null || iframe === void 0 ? void 0 : iframe.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) {
            _context3.next = 5;
            break;
          }
          _context3.next = 4;
          return cloneNode(iframe.contentDocument.body, {}, true);
        case 4:
          return _context3.abrupt("return", _context3.sent);
        case 5:
          _context3.next = 9;
          break;
        case 7:
          _context3.prev = 7;
          _context3.t0 = _context3["catch"](0);
        case 9:
          return _context3.abrupt("return", iframe.cloneNode(false));
        case 10:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 7]]);
  }));
  return _cloneIFrameElement.apply(this, arguments);
}
function cloneSingleNode(_x5, _x6) {
  return _cloneSingleNode.apply(this, arguments);
}
function _cloneSingleNode() {
  _cloneSingleNode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(node, options) {
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (!isInstanceOfElement(node, HTMLCanvasElement)) {
            _context4.next = 2;
            break;
          }
          return _context4.abrupt("return", cloneCanvasElement(node));
        case 2:
          if (!isInstanceOfElement(node, HTMLVideoElement)) {
            _context4.next = 4;
            break;
          }
          return _context4.abrupt("return", cloneVideoElement(node, options));
        case 4:
          if (!isInstanceOfElement(node, HTMLIFrameElement)) {
            _context4.next = 6;
            break;
          }
          return _context4.abrupt("return", cloneIFrameElement(node));
        case 6:
          return _context4.abrupt("return", node.cloneNode(false));
        case 7:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _cloneSingleNode.apply(this, arguments);
}
var isSlotElement = function isSlotElement(node) {
  return node.tagName != null && node.tagName.toUpperCase() === 'SLOT';
};
function cloneChildren(_x7, _x8, _x9) {
  return _cloneChildren.apply(this, arguments);
}
function _cloneChildren() {
  _cloneChildren = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(nativeNode, clonedNode, options) {
    var _a, _b, children;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          children = [];
          if (isSlotElement(nativeNode) && nativeNode.assignedNodes) {
            children = toArray(nativeNode.assignedNodes());
          } else if (isInstanceOfElement(nativeNode, HTMLIFrameElement) && ((_a = nativeNode.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) {
            children = toArray(nativeNode.contentDocument.body.childNodes);
          } else {
            children = toArray(((_b = nativeNode.shadowRoot) !== null && _b !== void 0 ? _b : nativeNode).childNodes);
          }
          if (!(children.length === 0 || isInstanceOfElement(nativeNode, HTMLVideoElement))) {
            _context5.next = 4;
            break;
          }
          return _context5.abrupt("return", clonedNode);
        case 4:
          _context5.next = 6;
          return children.reduce(function (deferred, child) {
            return deferred.then(function () {
              return cloneNode(child, options);
            }).then(function (clonedChild) {
              if (clonedChild) {
                clonedNode.appendChild(clonedChild);
              }
            });
          }, Promise.resolve());
        case 6:
          return _context5.abrupt("return", clonedNode);
        case 7:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _cloneChildren.apply(this, arguments);
}
function cloneCSSStyle(nativeNode, clonedNode) {
  var targetStyle = clonedNode.style;
  if (!targetStyle) {
    return;
  }
  var sourceStyle = window.getComputedStyle(nativeNode);
  if (sourceStyle.cssText) {
    targetStyle.cssText = sourceStyle.cssText;
    targetStyle.transformOrigin = sourceStyle.transformOrigin;
  } else {
    toArray(sourceStyle).forEach(function (name) {
      var value = sourceStyle.getPropertyValue(name);
      if (name === 'font-size' && value.endsWith('px')) {
        var reducedFont = Math.floor(parseFloat(value.substring(0, value.length - 2))) - 0.1;
        value = "".concat(reducedFont, "px");
      }
      if (isInstanceOfElement(nativeNode, HTMLIFrameElement) && name === 'display' && value === 'inline') {
        value = 'block';
      }
      if (name === 'd' && clonedNode.getAttribute('d')) {
        value = "path(".concat(clonedNode.getAttribute('d'), ")");
      }
      targetStyle.setProperty(name, value, sourceStyle.getPropertyPriority(name));
    });
  }
}
function cloneInputValue(nativeNode, clonedNode) {
  if (isInstanceOfElement(nativeNode, HTMLTextAreaElement)) {
    clonedNode.innerHTML = nativeNode.value;
  }
  if (isInstanceOfElement(nativeNode, HTMLInputElement)) {
    clonedNode.setAttribute('value', nativeNode.value);
  }
}
function cloneSelectValue(nativeNode, clonedNode) {
  if (isInstanceOfElement(nativeNode, HTMLSelectElement)) {
    var clonedSelect = clonedNode;
    var selectedOption = Array.from(clonedSelect.children).find(function (child) {
      return nativeNode.value === child.getAttribute('value');
    });
    if (selectedOption) {
      selectedOption.setAttribute('selected', '');
    }
  }
}
function decorate(nativeNode, clonedNode) {
  if (isInstanceOfElement(clonedNode, Element)) {
    cloneCSSStyle(nativeNode, clonedNode);
    clonePseudoElements(nativeNode, clonedNode);
    cloneInputValue(nativeNode, clonedNode);
    cloneSelectValue(nativeNode, clonedNode);
  }
  return clonedNode;
}
function ensureSVGSymbols(_x10, _x11) {
  return _ensureSVGSymbols.apply(this, arguments);
}
function _ensureSVGSymbols() {
  _ensureSVGSymbols = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(clone, options) {
    var uses, processedDefs, i, use, id, exist, definition, nodes, ns, svg, defs, _i;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          uses = clone.querySelectorAll ? clone.querySelectorAll('use') : [];
          if (!(uses.length === 0)) {
            _context6.next = 3;
            break;
          }
          return _context6.abrupt("return", clone);
        case 3:
          processedDefs = {};
          i = 0;
        case 5:
          if (!(i < uses.length)) {
            _context6.next = 18;
            break;
          }
          use = uses[i];
          id = use.getAttribute('xlink:href');
          if (!id) {
            _context6.next = 15;
            break;
          }
          exist = clone.querySelector(id);
          definition = document.querySelector(id);
          if (!(!exist && definition && !processedDefs[id])) {
            _context6.next = 15;
            break;
          }
          _context6.next = 14;
          return cloneNode(definition, options, true);
        case 14:
          processedDefs[id] = _context6.sent;
        case 15:
          i++;
          _context6.next = 5;
          break;
        case 18:
          nodes = Object.values(processedDefs);
          if (nodes.length) {
            ns = 'http://www.w3.org/1999/xhtml';
            svg = document.createElementNS(ns, 'svg');
            svg.setAttribute('xmlns', ns);
            svg.style.position = 'absolute';
            svg.style.width = '0';
            svg.style.height = '0';
            svg.style.overflow = 'hidden';
            svg.style.display = 'none';
            defs = document.createElementNS(ns, 'defs');
            svg.appendChild(defs);
            for (_i = 0; _i < nodes.length; _i++) {
              defs.appendChild(nodes[_i]);
            }
            clone.appendChild(svg);
          }
          return _context6.abrupt("return", clone);
        case 21:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _ensureSVGSymbols.apply(this, arguments);
}
export function cloneNode(_x12, _x13, _x14) {
  return _cloneNode.apply(this, arguments);
}
function _cloneNode() {
  _cloneNode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(node, options, isRoot) {
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          if (!(!isRoot && options.filter && !options.filter(node))) {
            _context7.next = 2;
            break;
          }
          return _context7.abrupt("return", null);
        case 2:
          return _context7.abrupt("return", Promise.resolve(node).then(function (clonedNode) {
            return cloneSingleNode(clonedNode, options);
          }).then(function (clonedNode) {
            return cloneChildren(node, clonedNode, options);
          }).then(function (clonedNode) {
            return decorate(node, clonedNode);
          }).then(function (clonedNode) {
            return ensureSVGSymbols(clonedNode, options);
          }));
        case 3:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _cloneNode.apply(this, arguments);
}